import { Skeleton, Tooltip } from '@heroui/react';

import { CopyableText } from '~/components/CopyableText';
import { useTruncatedTooltip } from '~/components/TruncatedText';

type AgentExecutionKeyCellProps = {
  agentExecutionKey: string;
};

export function AgentExecutionKeyCell({
  agentExecutionKey
}: AgentExecutionKeyCellProps) {
  const { ref, isTruncated } = useTruncatedTooltip(agentExecutionKey);

  if (!agentExecutionKey) return <span>-</span>;

  return (
    <CopyableText
      text={agentExecutionKey}
      className='whitespace-normal text-left font-mono text-body-regular-md lg:min-w-[142px] xl:min-w-[172px] 3xl:w-[336px]'
      data-testid='monitor-agent-logs-cell-agent-execution-key'
    >
      <Tooltip isDisabled={!isTruncated} content={agentExecutionKey}>
        <p
          ref={ref as React.RefObject<HTMLParagraphElement>}
          className='line-clamp-1 break-all'
        >
          {agentExecutionKey}
        </p>
      </Tooltip>
    </CopyableText>
  );
}

export function AgentExecutionKeyCellSkeleton() {
  return (
    <Skeleton className='h-5 lg:w-[120px] xl:w-[150px] 3xl:w-[358px] rounded' />
  );
}
